import React from 'react';
import { Whisper, Popover } from 'rsuite';
import { FaEllipsisV } from 'react-icons/fa';
import * as S from './styles';

export const CardGrid = S.CardGrid;
export const Card = S.Card;
export const CardHeader = S.CardHeader;
export const CardTitle = S.CardTitle;
export const CardSubtitle = S.CardSubtitle;
export const HeaderActions = S.HeaderActions;
export const CornerTag = S.CornerTag;
export const StatusBadge = S.StatusBadge;
export const ItemList = S.ItemList;
export const ItemRow = S.ItemRow;
export const ItemText = S.ItemText;
export const AddButton = S.AddButton;
export const IconButton = S.MenuButton;
export const Hint = S.Hint;
export const EmptyState = S.EmptyState;
export const LoadingState = S.LoadingState;

export function CardMenu({ options = [] }) {
  if (options.length === 0) return null;

  return (
    <Whisper
      trigger="click"
      placement="autoVertical"
      speaker={({ onClose, ...rest }, ref) => (
        <Popover ref={ref} {...rest} full>
          {options.map((option, index) => (
            <S.MenuOption
              key={index}
              $danger={option.danger}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
                option.onClick?.();
              }}
            >
              {option.label}
            </S.MenuOption>
          ))}
        </Popover>
      )}
    >
      <S.MenuButton onClick={(e) => e.stopPropagation()}>
        <FaEllipsisV size={12} />
      </S.MenuButton>
    </Whisper>
  );
}
